const STORAGE_KEY = "wayli.pendingBooking";

export const loadPendingBooking = () => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const savePendingBooking = (next) => {
  if (typeof window === "undefined") return next;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage write errors; fallback will be manual retry.
  }

  return next;
};

export const updatePendingBooking = (updater) => {
  const current = loadPendingBooking();
  const next = typeof updater === "function" ? updater(current) : updater;
  return savePendingBooking(next);
};

export const clearPendingBooking = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage errors.
  }
};

const paymentStorage = {
  loadPendingBooking,
  savePendingBooking,
  updatePendingBooking,
  clearPendingBooking,
};

export default paymentStorage;
